var map = {
	"./blue-right-arrow.svg": 124,
	"./bread-crumb-angle.svg": 1201,
	"./btn-quick-start.svg": 615,
	"./btn-view-all-course.svg": 395,
	"./claim.svg": 396,
	"./completed-chk.svg": 397,
	"./course_sections-icon-1.svg": 280,
	"./course_sections-icon-2.svg": 281,
	"./ddl-arrow.svg": 398,
	"./digital-maturity.gif": 184,
	"./digital-maturity.png": 1202,
	"./factory_future_icon.svg": 616,
	"./green-right-arrow.svg": 172,
	"./grid_icon.svg": 399,
	"./header-onboarding-1.gif": 1203,
	"./header-onboarding-1.svg": 1204,
	"./header-onboarding-2.gif": 1205,
	"./header-onboarding-2.svg": 1206,
	"./header-onboarding-3.gif": 1207,
	"./header-onboarding-3.svg": 1208,
	"./header-onboarding-4.gif": 1209,
	"./header-onboarding-4.svg": 1210,
	"./home-slider1.svg": 1211,
	"./home-slider2.svg": 1212,
	"./home-slider3.svg": 1213,
	"./home-slider4.svg": 1214,
	"./inv-claim.svg": 617,
	"./list_icon.svg": 400,
	"./my-assessment-icon.svg": 234,
	"./my-training-icon.svg": 235,
	"./opex_icon.svg": 1215,
	"./porduct-tour-card.svg": 401,
	"./quickstart2-1.svg": 1216,
	"./quickstart2-2.svg": 1217,
	"./quickstart2-3.svg": 1218,
	"./quikstart-1.svg": 402,
	"./quikstart-2.svg": 276,
	"./quikstart-3.svg": 403,
	"./quikstart-4.svg": 404,
	"./quikstart-5.svg": 405,
	"./share_assessment.svg": 618,
	"./step1-assessment-results-26.gif": 1219,
	"./step1-assessment-results.gif": 619,
	"./step2-assessment-results.gif": 620,
	"./step3-assessment-results.gif": 621,
	"./step4-assessment-results.gif": 622,
	"./uncompleted-chk.svg": 406,
	"./vision_icon.svg": 623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1200;